// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__OtL7X","Success":"Button_Success__1DvOz","Danger":"Button_Danger__15LWi"};